/**
 * @generated SignedSource<<4dda6d62d15884dcdd784b02fe1ec8b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StemBalanceResponse",
    "kind": "LinkedField",
    "name": "getBalanceByLabel",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "balance",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ImpulseGetBalanceByLabelQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ImpulseGetBalanceByLabelQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "57f0519c98635e9a4ecf3ec15939bd53",
    "id": null,
    "metadata": {},
    "name": "ImpulseGetBalanceByLabelQuery",
    "operationKind": "query",
    "text": "query ImpulseGetBalanceByLabelQuery {\n  getBalanceByLabel {\n    balance\n  }\n}\n"
  }
};
})();

node.hash = "c6c74858ae219f8ef61c2b374aebfd3d";

module.exports = node;
